import { atom, atomFamily } from "recoil";
import { GetRefundSourceConditionsQuery } from "../containers/financials/refunds/types/queries.generated";

export const pageSizeOptions = [25, 50, 100, 250]; // used in refunds and documents!
type ActivePageType = "refunds.activePage" | "documents.activePage";
type RowsPerPageType = "refunds.rowsPerPage" | "documents.rowsPerPage";

type ActiveTab = {
	key: "activeFinancialsTab";
	default: number;
};

type ActivePage = {
	key: ActivePageType;
	default: number;
};

type RowsPerPage = {
	key: RowsPerPageType;
	default: number;
};

type RefundInputMessage = {
	key: string;
	default: string;
};

type RefundAgreementConditions = {
	key: string;
	default: Array<GetRefundSourceConditionsQuery["baseAgreements"][number]>;
};

type RefundReview = {
	key: string;
	default: Array<string>;
};

const initialValueRefundsActivePage: ActivePage = {
	key: "refunds.activePage",
	default: 0,
};

const initialRefundsRowsPerPage: RowsPerPage = {
	key: "refunds.rowsPerPage",
	default: pageSizeOptions[0],
};

const initialActiveFinancialsTabState: ActiveTab = {
	key: "activeFinancialsTab",
	default: 0,
};

const initialRefundInputMessage: RefundInputMessage = {
	key: "refundInput",
	default: "",
};

const initialRefundReviewState: RefundReview = {
	key: "refundReview",
	default: [],
};

const initialrefundAgreementConditions: RefundAgreementConditions = {
	key: "refundAgreementConditions",
	default: [],
};

export const refundsActivePage = atom(initialValueRefundsActivePage);
export const refundsRowsPerPage = atom(initialRefundsRowsPerPage);
export const activeFinancialsTabState = atom(initialActiveFinancialsTabState);
export const initialRefundInputMessageState = atomFamily(initialRefundInputMessage);
export const refundReview = atom(initialRefundReviewState);
